exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".course{cursor:pointer;min-height:300px}.course .card{transition:all .3s cubic-bezier(.25,.8,.25,1)}.course .card:hover{border:none;box-shadow:0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22)}.p.course.small{padding:0}.range{background:#ccc;height:22px;width:100%;top:-2px;position:relative}.range .progress{background:#009ae3;height:22px;width:0}.range .progress-txt{color:#fff;position:relative;margin-left:auto;margin-right:auto;text-align:center;width:100%;top:-19px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/js/course/Course/Course.less
 ** module id = 507
 ** module chunks = 1
 **/